import api from "./api";

export const getAIAdvice = async (userId) => {
  const adviceResponse = await api.get("/ai/advice/" + userId);
  return adviceResponse.data;
};

export const sendChatMessage = async (message, userId) => {
  try {
    const response = await api.post("/ai/chat", {
      message,
      userId,
    });
    return response.data;
  } catch (error) {
    console.error("Error sending chat message:", error);
    throw error;
  }
};

export const getConversationHistory = async (userId, conversationId) => {
  try {
    const response = await api.get(
      `/ai/chat/history/${userId}/${conversationId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error getting conversation history:", error);
    throw error;
  }
};

export const getLatestConversation = async (userId) => {
  try {
    const response = await api.get(`/ai/chat/latest/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error getting latest conversation:", error);
    throw error;
  }
};

export const clearConversation = async (userId, conversationId) => {
  try {
    const response = await api.delete(`/ai/chat/${userId}/${conversationId}`);
    return response.data;
  } catch (error) {
    console.error("Error clearing conversation:", error);
    throw error;
  }
};

export const getRecentConversations = async () => {
  try {
    const response = await api.get("/ai/conversations");
    return response.data;
  } catch (error) {
    console.error("Error getting recent conversations:", error);
    throw error;
  }
};

export const savePrompt = async (prompt) => {
  try {
    const response = await api.post("/ai-prompt", {
      prompt,
    });
    return response.data;
  } catch (error) {
    console.error("Error saving prompt:", error);
    throw error;
  }
};

export const getPrompt = async () => {
  try {
    const response = await api.get("/ai-prompt/");
    return response.data;
  } catch (error) {
    console.error("Error getting prompt:", error);
    throw error;
  }
};

export const getChatVisibility = async () => {
  try {
    const response = await api.get("/ai-prompt/showChat");
    return response.data;
  } catch (error) {
    console.error("Error getting chat visibility:", error);
    throw error;
  }
};

export const setChatVisibility = async (showChat) => {
  try {
    const response = await api.post("/ai-prompt/showChat", { showChat });
    return response.data;
  } catch (error) {
    console.error("Error setting chat visibility:", error);
    throw error;
  }
};
